module.exports = __webpack_public_path__ + "static/media/bg-planet-blue.31e1db52.svg";